export default "__VITE_ASSET__a148c8e4__"